import React, {useEffect, useState} from 'react';
import config from "../../../../config";
import {generalModalStyles} from "../../../../utils/General";
import Modal from '../../../../components-new/ui/Modal';
import Translate from "../../../../components/Translate";
import Input from "../../../../components-new/form/Input";
import countries from "../../../../utils/Countries";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import {updateCompanyRequested} from "../../../../services/company/action";
import {connect} from "react-redux";
import DropdownSelect from "../../../../components-new/form/DropdownSelect";
import BriefcaseBusinessIcon from "../../../../assets/icons/BriefcaseBusinessIcon";
import './SettingsModal.css';

const CompanySettingsModal = ({isOpen, onRequestClose, company, updateCompany}) => {
    const [companyName, setCompanyName] = useState("");
    const [organization, setOrganization] = useState("");
    const [country, setCountry] = useState("");
    const [address, setAddress] = useState("");
    const [tin, setTin] = useState("");
    const [passport, setPassport] = useState("");

    useEffect(() => {
        if (company) {
            setCompanyName(company.name);
            setOrganization(company.organization);

            const countryValue = countries.find((item) => (item.value === company.country));
            setCountry(countryValue);

            setAddress(company.address);
            setTin(company.tin);
            setPassport(company.passport);
        }
    }, [company])

    const saveCompany = () => {
        const companyData = {
            name: companyName,
            domain: company.domain,
            image: company.image,
            organization: organization,
            country: country.value,
            address: address,
            passport: passport,
            tin: tin
        }
        Object.assign(companyData, {
            status: company.status,
        });
        updateCompany(companyData);
        onRequestClose();
    }

    const organizationOptions = config.organizationTypes.map((item) => (
        {value: item.value, label: item.title}
    ))

    return (
        <Modal
               closeTimeoutMS={config.closeTimeoutMS}
               isOpen={isOpen}
               style={generalModalStyles.menuItemModalStyles}
               onRequestClose={onRequestClose}
               onCancel={onRequestClose}
               onSubmit={saveCompany}
               title={<Translate text="company"/>}
               description={<Translate text="companyDescription"/>}
               headerIcon={<BriefcaseBusinessIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
               headerSeparator
               footerSeparator
               footer={
                   <React.Fragment>
                       <SilverButton type="button" width="auto" height="40px" onClick={onRequestClose}>
                           <Translate text="close"/>
                       </SilverButton>
                       <BlueButton type="button" width="auto" height="40px" onClick={saveCompany}>
                           <Translate text="save"/>
                       </BlueButton>
                   </React.Fragment>
               }
        >
            <div className="settings-modal-fields">
                        <Input
                            label={<Translate text="companyName"/>}
                            maxLength={100}
                            name={'companyName'}
                            style={{height: '40px'}}
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                        />

                    <div className="settings-modal-select-field">
                        <div className="standard-input-label">
                            <Translate text="organizationType"/>
                        </div>
                        <DropdownSelect
                            selectedValue={organizationOptions.find(o => o.value === organization)}
                            onChange={(e) => setOrganization(e.value)}
                            options={organizationOptions}
                            styles={{
                                width: "100%",
                            }}
                            variant={'outline'}
                        />
                    </div>

                        <Input
                            label={<Translate text="country"/>}
                            maxLength={100}
                            name={'companyCountry'}
                            disabled={true}
                            style={{height: '40px'}}
                            value={country ? country.title : ''}
                            onChange={(e) => setCountry(e.target.value)}
                        />

                        <Input
                            label={<Translate text="address"/>}
                            maxLength={100}
                            name={'address'}
                            style={{height: '40px'}}
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />

                    {country && country.value === 'am' && organization && organization === config.organizationTypes[0].value &&
                            <Input
                                label={<Translate text="tin"/>}
                                maxLength={8}
                                name={'tin'}
                                style={{height: '40px'}}
                                value={tin}
                                onChange={(e) => setTin(e.target.value)}
                            />
                    }

                    {country && country.value === 'am' && organization && organization === config.organizationTypes[1].value &&
                            <Input
                                label={<Translate text="passport"/>}
                                maxLength={9}
                                name={'passport'}
                                style={{height: '40px'}}
                                value={passport}
                                onChange={(e) => setPassport(e.target.value)}
                            />
                    }
            </div>
        </Modal>
    );
};

const mapDispatchToProps = dispatch => ({
    updateCompany: (companyInfo) => {
        dispatch(updateCompanyRequested(companyInfo));
    },
});

export default connect(null, mapDispatchToProps)(CompanySettingsModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/CompanySettingsModal.jsx